import { TemplateType } from '@src/components/AdminHome/Channels/WhatsApp/WhatsAppTemplates/types';
import { WhatsAppTemplatesState } from '@src/reducers/whatsAppTemplates';
import type { RootState } from '@src/store/reduxstore';
import { WhatsAppTemplate, WhatsAppTemplateStatus } from '@types';

export const selectWhatsAppTemplates = (state: RootState) =>
  state.whatsAppTemplates as WhatsAppTemplatesState;

export const selectActiveTemplatesByBotAccountId = (
  state: RootState,
  botAccountId: number
): WhatsAppTemplate[] => {
  const whatsAppTemplatesState = state.whatsAppTemplates;
  if (
    !botAccountId ||
    whatsAppTemplatesState.filter.botAccountId !== String(botAccountId)
  ) {
    return [];
  }
  return whatsAppTemplatesState.data.filter(
    item => item.status === WhatsAppTemplateStatus.ACTIVE
  );
};

export const selectSaveWhatsAppTemplate = (state: RootState) =>
  state.saveWhatsAppTemplate;

export const selectWhatsAppTemplatesWithoutCallType = (state: RootState) =>
  state.whatsAppTemplates.contactTemplates.filter(
    template =>
      !template.templatedMsg.templateComponent?.some(
        button => button?.type === TemplateType.CALL_PERMISSION
      )
  );

export const selectDefaultWhatsAppTemplateByContactId = (state: RootState) => {
  const { contactTemplates } = state.whatsAppTemplates;

  const defaultTemplates = contactTemplates.filter(
    temp => temp.templatedMsg.defaultToResume
  );

  let initialTemplate;

  if (defaultTemplates.length > 0) {
    [initialTemplate] = defaultTemplates;
  } else {
    [initialTemplate] = contactTemplates;
  }
  return initialTemplate;
};
